export const bottleDescriptions = {
	PREMIUM: `The perfect olive oil for cooking, Premium is ideal for baking, roasting, and frying. It takes any 
	dish from fried eggs, to baked goods to the next level. It's produced from the late-harvest olives 
	and cold-pressed within 24 hours of picking.`,
	LUXE: `Luxe is a versatile, high-polyphenol olive oil, cold-pressed within 24 hours of harvest. 
	With its pungent, fresh flavor, Luxe elevates everyday meals — perfect for salad dressings, 
	dipping bread, or mixing into marinades.`,
	PRIVATE_RESERVE:`Private Reserve is a high-polyphenol olive oil, cold-pressed within one hour 
	of harvest. Smooth yet robust, it’s the kind of olive oil that transforms both everyday meals 
	and gourmet dishes into something extraordinary. It’s the ultimate finishing oil for salads, 
	pasta, grilled meats, or even desserts like ice cream and baked goods.`,
	TASTING_COLLECTION:`Get a bottle each of our Luxe and Private Reserve olive oils. This package is 
	great for those who want to taste both before becoming a member or making a large order. It is also
	a unique and popular gift for those who appreciate fine cuisine.`
}

